import { render, staticRenderFns } from "./subDomain.vue?vue&type=template&id=3313375c&"
import script from "./subDomain.vue?vue&type=script&lang=js&"
export * from "./subDomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports